import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { IHeaderGroupParams, RowNode } from 'ag-grid-community';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import { UserInfo } from './user-info';

interface UserEmulationGroupParams extends IHeaderGroupParams {
    node: RowNode;
}

@Component({
    selector: 'user-emulation-group',
    template: require('./user-emulation-group-renderer.component.html'),
    styles: [require('./user-emulation-group-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserEmulationGroupRenderer implements IHeaderGroupAngularComp {
    public userTitle: string;
    public user: UserInfo;

    constructor(private location: Location) { }

    public agInit(params: UserEmulationGroupParams) {
        this.user = params.node.childrenAfterGroup[0].data as UserInfo;
        this.userTitle = params.node.key;
    }

    public getEmulateUserUrl() {
        return this.location.prepareExternalUrl('/emulate-user');
    }
}